import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-18-rajeev-chaba-guest.webp";
import ThumbImg from "../../assets/images/conversations/018.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: rc2-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .rc2-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .rc2-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ── HERO ── */
  .rc2-hero { padding-top: 60px; padding-bottom: 60px; }
  .rc2-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .rc2-hero__left { display: flex; flex-direction: column; gap: 44px; }
  .rc2-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .rc2-hero__title.rc2-visible { opacity: 1; transform: translateY(0); }
  .rc2-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .rc2-hero__spotify.rc2-visible { opacity: 1; transform: translateY(0); }
  .rc2-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .rc2-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .rc2-hero__right.rc2-visible { opacity: 1; transform: translateY(0); }

  /* ── YOUTUBE THUMB ── */
  .rc2-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .rc2-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .rc2-yt-thumb:hover img { opacity: 0.85; }
  .rc2-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .rc2-yt-thumb__play img { width: 40px; height: 44px; }
  .rc2-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .rc2-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  /* ── BODY ── */
  .rc2-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .rc2-body.rc2-visible { opacity: 1; transform: translateY(0); }
  .rc2-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .rc2-body__para:last-child { margin-bottom: 0; }

  /* ── GUEST ── */
  .rc2-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .rc2-guest.rc2-visible { opacity: 1; transform: translateY(0); }
  .rc2-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .rc2-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .rc2-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .rc2-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .rc2-inner { padding-left: 32px; padding-right: 32px; }
    .rc2-hero { padding-top: 32px; padding-bottom: 48px; }
    .rc2-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .rc2-hero__title { font-size: 24px; }
    .rc2-hero__left { gap: 16px; }
    .rc2-guest__title { font-size: 24px; margin-bottom: 24px; }
    .rc2-guest__photo-bg { width: 260px; height: 300px; }
    .rc2-guest__name { font-size: 24px; margin-top: 18px; }
    .rc2-body__para { font-size: 14px; margin-bottom: 12px; }
    .rc2-body { padding-bottom: 48px; }
    .rc2-guest { padding-bottom: 48px; }
    .rc2-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .rc2-inner { padding-left: 16px; padding-right: 16px; }
    .rc2-hero { padding-top: 51px; padding-bottom: 30px; }
    .rc2-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .rc2-hero__left { gap: 30px; }
    .rc2-hero__title { font-size: 30px; }
    .rc2-body__para { font-size: 16px; margin-bottom: 10px; }
    .rc2-guest__title { font-size: 30px; margin-bottom: 20px; text-align: left; }
    .rc2-guest__photo-bg { width: 100%; height: 386px; }
    .rc2-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .rc2-body { padding-bottom: 30px; }
    .rc2-guest { padding-bottom: 30px; }
    .rc2-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("rc2-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "tBHWsE7fTDs";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="rc2-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 18 Rajeev Chaba MG Motor India"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div
      className="rc2-yt-thumb"
      onClick={() => setPlaying(true)}
      role="button"
      aria-label="Play video"
    >
      <img src={ThumbImg} alt="EP 18 Rajeev Chaba thumbnail" />
      <div className="rc2-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="rc2-hero">
      <div className="rc2-inner">
        <div className="rc2-hero__grid">
          <div className="rc2-hero__left">
            <h1 ref={titleRef} className="rc2-hero__title">
              EP 18 | Is this the right time to move from ICE vehicles to EVs? | Rajeev CHABA | MG Motor India
            </h1>
            <div ref={spotifyRef} className="rc2-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/2rLbC9w9upF6t11YilcZEH?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 18 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="rc2-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="rc2-body">
      <div className="rc2-inner">
        <p className="rc2-body__para">
          Post COP26 most major economies have set themselves aggressive targets to reduce greenhouse gas emissions with many releasing objectives to achieve zero-emission mobility through battery-electric and hydrogen mobility within this decade. Even the big oil companies are jumping on to surf this new energy wave. Notice how French oil company Total subtly changed its name to Total Energies and how Reliance + British Petroleum (now referred to as Beyond Petroleum) have come together in India to create Jio-BP, a joint venture that will also roll out a large EV charging network.
        </p>
        <p className="rc2-body__para">
          With over 15,000 electric cars, a few hundred thousand electric bikes, and some 2 million electric rickshaws on roads in India already, the big move to electric is well underway. But new EV buyers continue to have doubts when making the decision to switch wondering for example, are EVs truly 100% clean mobility? What happens to your new EV after the useful life of the battery? Does one need to buy a whole new set of batteries for example? When will the finance industry get their heads around financing electric vehicle procurement and most importantly how can the EV industry address the issue of sustainability and the second life of the batteries?
        </p>
        <p className="rc2-body__para">
          These are some of the issues that we will dive into with an industry leader best place to answer some of these questions. In this episode, we speak with Rajeev CHABA, President &amp; Managing Director of MG Motors India.
        </p>
        <p className="rc2-body__para">
          Energizing India Podcast is produced by Ador Digatron Pvt Ltd
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="rc2-guest">
      <div className="rc2-inner">
        <h2 className="rc2-guest__title">Our Guest</h2>
        <div>
          <div className="rc2-guest__photo-bg">
            <img src={GuestImg} alt="Rajeev Chaba" />
          </div>
          <p className="rc2-guest__name">Rajeev CHABA</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep18RajeevChaba() {
  return (
    <>
      <style>{CSS}</style>
      <div className="rc2-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}